export default {
  title: {
    id: 'bo_seller.options.shipping.back_pack.title',
    defaultMessage: 'Take Advantage of BackPack',
  },
  subtitle: {
    id: 'bo_seller.options.shipping.back_pack.subtitle',
    defaultMessage:
      "Get BackMarket branded packaging that's as good for your bottom line as it is for the environment.",
  },
  infoMessage: {
    id: 'bo_seller.options.shipping.back_pack.info_message',
    defaultMessage:
      "With smartphone packaging included in CCBM, all you have to do is order. And pick up laptop packaging while you're at it.",
  },
  orderNow: {
    id: 'bo_seller.options.shipping.back_pack.order_now',
    defaultMessage: 'Order now',
  },
}
